import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["variant"];
import React, { forwardRef } from 'react';
import StickerImage from './StickerImage';
import RoseImage from './RoseImage';
import { STYLE_ROSE, STYLE_STICKER } from 'utils/image/styles';
var BadgeImage = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? STYLE_STICKER : _ref$variant,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  switch (variant) {
    case STYLE_ROSE:
      {
        return /*#__PURE__*/React.createElement(RoseImage, _extends({
          ref: ref,
          "data-style": STYLE_ROSE
        }, otherProps));
      }
    case STYLE_STICKER:
    default:
      {
        return /*#__PURE__*/React.createElement(StickerImage, _extends({
          ref: ref,
          "data-style": STYLE_STICKER
        }, otherProps));
      }
  }
});
BadgeImage.displayName = 'BadgeImage';
export default BadgeImage;